import axios, { InternalAxiosRequestConfig } from 'axios'
import { isConnectivityAvailable } from '../../feat/connectivity/connectivityListener'
import { useGuestStore } from '../../feat/guest/guest.store'
export const guestAbortRequestInterceptor = (
    request: InternalAxiosRequestConfig
) => {
    if (request.NOT_IN_GUEST === true) {
        if (useGuestStore.getState().isGuestMode) {
            throw new axios.Cancel('Request cancelled: Guest mode restriction.')
        }
    }
    if (!isConnectivityAvailable.value) {
        throw new axios.Cancel('Request cancelled: No connectivity.')
    }

    return {
        ...request,
    }
}
